import type { TCountryCode } from '@/shared/types';

export enum CurrencyCode {
  ARS = 'ARS',
  BRL = 'BRL',
  CLP = 'CLP',
  CRC = 'CRC',
  COP = 'COP',
  HNL = 'HNL',
  EUR = 'EUR',
  MXN = 'MXN',
  PEN = 'PEN',
  PYG = 'PYG',
  USD = 'USD',
}

export const MAX_STAGES_AVAILABLE = 30;

// Re-export GraphQL error types for convenience
export { GRAPHQL_ERROR_TYPES } from './constants/graphql-error-types';

const countryCodes: TCountryCode[] = [
  { iso: 'AF', label: 'Afganistán (+93)', value: '+93' },
  { iso: 'AL', label: 'Albania (+355)', value: '+355' },
  { iso: 'DE', label: 'Alemania (+49)', value: '+49' },
  { iso: 'AD', label: 'Andorra (+376)', value: '+376' },
  { iso: 'AO', label: 'Angola (+244)', value: '+244' },
  { iso: 'AR', label: 'Argentina (+54)', value: '+54' },
  { iso: 'AM', label: 'Armenia (+374)', value: '+374' },
  { iso: 'AU', label: 'Australia (+61)', value: '+61' },
  { iso: 'AT', label: 'Austria (+43)', value: '+43' },
  { iso: 'BE', label: 'Bélgica (+32)', value: '+32' },
  { iso: 'BO', label: 'Bolivia (+591)', value: '+591' },
  { iso: 'BR', label: 'Brasil (+55)', value: '+55' },
  { iso: 'CA', label: 'Canadá (+1)', value: '+1' },
  { iso: 'CL', label: 'Chile (+56)', value: '+56' },
  { iso: 'CN', label: 'China (+86)', value: '+86' },
  { iso: 'CO', label: 'Colombia (+57)', value: '+57' },
  { iso: 'CR', label: 'Costa Rica (+506)', value: '+506' },
  { iso: 'HR', label: 'Croacia (+385)', value: '+385' },
  { iso: 'CU', label: 'Cuba (+53)', value: '+53' },
  { iso: 'DK', label: 'Dinamarca (+45)', value: '+45' },
  { iso: 'EC', label: 'Ecuador (+593)', value: '+593' },
  { iso: 'EG', label: 'Egipto (+20)', value: '+20' },
  { iso: 'SV', label: 'El Salvador (+503)', value: '+503' },
  { iso: 'AE', label: 'Emiratos Árabes Unidos (+971)', value: '+971' },
  { iso: 'ES', label: 'España (+34)', value: '+34' },
  { iso: 'US', label: 'Estados Unidos (+1)', value: '+1' },
  { iso: 'EE', label: 'Estonia (+372)', value: '+372' },
  { iso: 'PH', label: 'Filipinas (+63)', value: '+63' },
  { iso: 'FI', label: 'Finlandia (+358)', value: '+358' },
  { iso: 'FR', label: 'Francia (+33)', value: '+33' },
  { iso: 'GR', label: 'Grecia (+30)', value: '+30' },
  { iso: 'GT', label: 'Guatemala (+502)', value: '+502' },
  { iso: 'HN', label: 'Honduras (+504)', value: '+504' },
  { iso: 'HU', label: 'Hungría (+36)', value: '+36' },
  { iso: 'IN', label: 'India (+91)', value: '+91' },
  { iso: 'ID', label: 'Indonesia (+62)', value: '+62' },
  { iso: 'IE', label: 'Irlanda (+353)', value: '+353' },
  { iso: 'IS', label: 'Islandia (+354)', value: '+354' },
  { iso: 'IL', label: 'Israel (+972)', value: '+972' },
  { iso: 'IT', label: 'Italia (+39)', value: '+39' },
  { iso: 'JP', label: 'Japón (+81)', value: '+81' },
  { iso: 'MX', label: 'México (+52)', value: '+52' },
  { iso: 'NI', label: 'Nicaragua (+505)', value: '+505' },
  { iso: 'NO', label: 'Noruega (+47)', value: '+47' },
  { iso: 'NL', label: 'Países Bajos (+31)', value: '+31' },
  { iso: 'PA', label: 'Panamá (+507)', value: '+507' },
  { iso: 'PY', label: 'Paraguay (+595)', value: '+595' },
  { iso: 'PE', label: 'Perú (+51)', value: '+51' },
  { iso: 'PL', label: 'Polonia (+48)', value: '+48' },
  { iso: 'PT', label: 'Portugal (+351)', value: '+351' },
  { iso: 'GB', label: 'Reino Unido (+44)', value: '+44' },
  { iso: 'CZ', label: 'República Checa (+420)', value: '+420' },
  { iso: 'DO', label: 'República Dominicana (+1)', value: '+1' },
  { iso: 'RO', label: 'Rumania (+40)', value: '+40' },
  { iso: 'RU', label: 'Rusia (+7)', value: '+7' },
  { iso: 'SE', label: 'Suecia (+46)', value: '+46' },
  { iso: 'CH', label: 'Suiza (+41)', value: '+41' },
  { iso: 'UY', label: 'Uruguay (+598)', value: '+598' },
  { iso: 'VE', label: 'Venezuela (+58)', value: '+58' },
];

const countryCodesEn: TCountryCode[] = [
  { iso: 'AF', label: 'Afghanistan (+93)', value: '+93' },
  { iso: 'AL', label: 'Albania (+355)', value: '+355' },
  { iso: 'DE', label: 'Germany (+49)', value: '+49' },
  { iso: 'AD', label: 'Andorra (+376)', value: '+376' },
  { iso: 'AO', label: 'Angola (+244)', value: '+244' },
  { iso: 'AR', label: 'Argentina (+54)', value: '+54' },
  { iso: 'AM', label: 'Armenia (+374)', value: '+374' },
  { iso: 'AU', label: 'Australia (+61)', value: '+61' },
  { iso: 'AT', label: 'Austria (+43)', value: '+43' },
  { iso: 'BE', label: 'Belgium (+32)', value: '+32' },
  { iso: 'BO', label: 'Bolivia (+591)', value: '+591' },
  { iso: 'BR', label: 'Brazil (+55)', value: '+55' },
  { iso: 'CA', label: 'Canada (+1)', value: '+1' },
  { iso: 'CL', label: 'Chile (+56)', value: '+56' },
  { iso: 'CN', label: 'China (+86)', value: '+86' },
  { iso: 'CO', label: 'Colombia (+57)', value: '+57' },
  { iso: 'CR', label: 'Costa Rica (+506)', value: '+506' },
  { iso: 'HR', label: 'Croatia (+385)', value: '+385' },
  { iso: 'CU', label: 'Cuba (+53)', value: '+53' },
  { iso: 'DK', label: 'Denmark (+45)', value: '+45' },
  { iso: 'EC', label: 'Ecuador (+593)', value: '+593' },
  { iso: 'EG', label: 'Egypt (+20)', value: '+20' },
  { iso: 'SV', label: 'El Salvador (+503)', value: '+503' },
  { iso: 'AE', label: 'United Arab Emirates (+971)', value: '+971' },
  { iso: 'ES', label: 'Spain (+34)', value: '+34' },
  { iso: 'US', label: 'United States (+1)', value: '+1' },
  { iso: 'EE', label: 'Estonia (+372)', value: '+372' },
  { iso: 'PH', label: 'Philippines (+63)', value: '+63' },
  { iso: 'FI', label: 'Finland (+358)', value: '+358' },
  { iso: 'FR', label: 'France (+33)', value: '+33' },
  { iso: 'GR', label: 'Greece (+30)', value: '+30' },
  { iso: 'GT', label: 'Guatemala (+502)', value: '+502' },
  { iso: 'HN', label: 'Honduras (+504)', value: '+504' },
  { iso: 'HU', label: 'Hungary (+36)', value: '+36' },
  { iso: 'IN', label: 'India (+91)', value: '+91' },
  { iso: 'ID', label: 'Indonesia (+62)', value: '+62' },
  { iso: 'IE', label: 'Ireland (+353)', value: '+353' },
  { iso: 'IS', label: 'Iceland (+354)', value: '+354' },
  { iso: 'IL', label: 'Israel (+972)', value: '+972' },
  { iso: 'IT', label: 'Italy (+39)', value: '+39' },
  { iso: 'JP', label: 'Japan (+81)', value: '+81' },
  { iso: 'MX', label: 'Mexico (+52)', value: '+52' },
  { iso: 'NI', label: 'Nicaragua (+505)', value: '+505' },
  { iso: 'NO', label: 'Norway (+47)', value: '+47' },
  { iso: 'NL', label: 'Netherlands (+31)', value: '+31' },
  { iso: 'PA', label: 'Panama (+507)', value: '+507' },
  { iso: 'PY', label: 'Paraguay (+595)', value: '+595' },
  { iso: 'PE', label: 'Peru (+51)', value: '+51' },
  { iso: 'PL', label: 'Poland (+48)', value: '+48' },
  { iso: 'PT', label: 'Portugal (+351)', value: '+351' },
  { iso: 'GB', label: 'United Kingdom (+44)', value: '+44' },
  { iso: 'CZ', label: 'Czech Republic (+420)', value: '+420' },
  { iso: 'DO', label: 'Dominican Republic (+1)', value: '+1' },
  { iso: 'RO', label: 'Romania (+40)', value: '+40' },
  { iso: 'RU', label: 'Russia (+7)', value: '+7' },
  { iso: 'SE', label: 'Sweden (+46)', value: '+46' },
  { iso: 'CH', label: 'Switzerland (+41)', value: '+41' },
  { iso: 'UY', label: 'Uruguay (+598)', value: '+598' },
  { iso: 'VE', label: 'Venezuela (+58)', value: '+58' },
];

const countryCodesPt: TCountryCode[] = [
  { iso: 'AF', label: 'Afeganistão (+93)', value: '+93' },
  { iso: 'AL', label: 'Albânia (+355)', value: '+355' },
  { iso: 'DE', label: 'Alemanha (+49)', value: '+49' },
  { iso: 'AD', label: 'Andorra (+376)', value: '+376' },
  { iso: 'AO', label: 'Angola (+244)', value: '+244' },
  { iso: 'AR', label: 'Argentina (+54)', value: '+54' },
  { iso: 'AM', label: 'Armênia (+374)', value: '+374' },
  { iso: 'AU', label: 'Austrália (+61)', value: '+61' },
  { iso: 'AT', label: 'Áustria (+43)', value: '+43' },
  { iso: 'BE', label: 'Bélgica (+32)', value: '+32' },
  { iso: 'BO', label: 'Bolívia (+591)', value: '+591' },
  { iso: 'BR', label: 'Brasil (+55)', value: '+55' },
  { iso: 'CA', label: 'Canadá (+1)', value: '+1' },
  { iso: 'CL', label: 'Chile (+56)', value: '+56' },
  { iso: 'CN', label: 'China (+86)', value: '+86' },
  { iso: 'CO', label: 'Colômbia (+57)', value: '+57' },
  { iso: 'CR', label: 'Costa Rica (+506)', value: '+506' },
  { iso: 'HR', label: 'Croácia (+385)', value: '+385' },
  { iso: 'CU', label: 'Cuba (+53)', value: '+53' },
  { iso: 'DK', label: 'Dinamarca (+45)', value: '+45' },
  { iso: 'EC', label: 'Equador (+593)', value: '+593' },
  { iso: 'EG', label: 'Egito (+20)', value: '+20' },
  { iso: 'SV', label: 'El Salvador (+503)', value: '+503' },
  { iso: 'AE', label: 'Emirados Árabes Unidos (+971)', value: '+971' },
  { iso: 'ES', label: 'Espanha (+34)', value: '+34' },
  { iso: 'US', label: 'Estados Unidos (+1)', value: '+1' },
  { iso: 'EE', label: 'Estônia (+372)', value: '+372' },
  { iso: 'PH', label: 'Filipinas (+63)', value: '+63' },
  { iso: 'FI', label: 'Finlândia (+358)', value: '+358' },
  { iso: 'FR', label: 'França (+33)', value: '+33' },
  { iso: 'GR', label: 'Grécia (+30)', value: '+30' },
  { iso: 'GT', label: 'Guatemala (+502)', value: '+502' },
  { iso: 'HN', label: 'Honduras (+504)', value: '+504' },
  { iso: 'HU', label: 'Hungria (+36)', value: '+36' },
  { iso: 'IN', label: 'Índia (+91)', value: '+91' },
  { iso: 'ID', label: 'Indonésia (+62)', value: '+62' },
  { iso: 'IE', label: 'Irlanda (+353)', value: '+353' },
  { iso: 'IS', label: 'Islândia (+354)', value: '+354' },
  { iso: 'IL', label: 'Israel (+972)', value: '+972' },
  { iso: 'IT', label: 'Itália (+39)', value: '+39' },
  { iso: 'JP', label: 'Japão (+81)', value: '+81' },
  { iso: 'MX', label: 'México (+52)', value: '+52' },
  { iso: 'NI', label: 'Nicarágua (+505)', value: '+505' },
  { iso: 'NO', label: 'Noruega (+47)', value: '+47' },
  { iso: 'NL', label: 'Países Baixos (+31)', value: '+31' },
  { iso: 'PA', label: 'Panamá (+507)', value: '+507' },
  { iso: 'PY', label: 'Paraguai (+595)', value: '+595' },
  { iso: 'PE', label: 'Peru (+51)', value: '+51' },
  { iso: 'PL', label: 'Polônia (+48)', value: '+48' },
  { iso: 'PT', label: 'Portugal (+351)', value: '+351' },
  { iso: 'GB', label: 'Reino Unido (+44)', value: '+44' },
  { iso: 'CZ', label: 'República Tcheca (+420)', value: '+420' },
  { iso: 'DO', label: 'República Dominicana (+1)', value: '+1' },
  { iso: 'RO', label: 'Romênia (+40)', value: '+40' },
  { iso: 'RU', label: 'Rússia (+7)', value: '+7' },
  { iso: 'SE', label: 'Suécia (+46)', value: '+46' },
  { iso: 'CH', label: 'Suíça (+41)', value: '+41' },
  { iso: 'UY', label: 'Uruguai (+598)', value: '+598' },
  { iso: 'VE', label: 'Venezuela (+58)', value: '+58' },
];

export const getCountryCodes = (
  language: 'es' | 'en' | 'pt' = 'es',
): TCountryCode[] => {
  switch (language) {
    case 'en':
      return countryCodesEn;
    case 'pt':
      return countryCodesPt;
    case 'es':
    default:
      return countryCodes;
  }
};
